"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSelectionInput = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var test_helpers_1 = require("../../lib/test-helpers");
var colors_1 = require("../../theme/colors");
var box_1 = require("../box");
var button_1 = require("../button");
var flexbox_1 = require("../flexbox");
var icons_1 = require("../icons");
var padding_1 = require("../padding");
var stack_1 = require("../stack");
var text_1 = require("../text");
function ObjectSelectionInput(_a) {
    var _b;
    var title = _a.title, subtitle = _a.subtitle, buttonLabel = _a.buttonLabel, children = _a.children, iconType = _a.iconType, selected = _a.selected, onClear = _a.onClear, onSelect = _a.onSelect, disabled = _a.disabled, ariaLabel = _a["aria-label"], error = _a.error, propTestId = _a.testId;
    var testId = (_b = propTestId !== null && propTestId !== void 0 ? propTestId : ariaLabel) !== null && _b !== void 0 ? _b : (typeof title === 'string' ? (0, test_helpers_1.generateTestId)((0, lodash_1.kebabCase)(title.toString()), 'object-selection-input') : undefined);
    return (react_1.default.createElement(box_1.Box, { "aria-label": ariaLabel },
        react_1.default.createElement(box_1.Box, { border: 0, backgroundColor: colors_1.colors.steel[50], style: {
                borderRadius: 4,
                borderColor: colors_1.colors.steel[50],
            }, testId: testId },
            react_1.default.createElement(padding_1.Padding, { size: 24 },
                react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between", alignItems: "center" },
                    react_1.default.createElement(flexbox_1.FlexCell, null,
                        react_1.default.createElement(text_1.Text, { weight: 600, color: error ? 'error' : 'dark' }, title),
                        react_1.default.createElement(text_1.Text, { color: error ? 'error' : 'default' }, subtitle)),
                    react_1.default.createElement(flexbox_1.FlexCell, null,
                        react_1.default.createElement(padding_1.Padding, { left: 12 }, selected ? (react_1.default.createElement(button_1.Button, { size: "primary", onClick: function () {
                                onSelect();
                            }, disabled: disabled, type: "button", testId: (0, test_helpers_1.generateTestId)(testId, 'button') },
                            react_1.default.createElement("span", null, buttonLabel),
                            react_1.default.createElement(icons_1.IconClose, { style: {
                                    marginLeft: 8,
                                }, role: "button", tabIndex: 0, "aria-label": "clear selection", "aria-disabled": disabled, onKeyDown: function (e) {
                                    if (!disabled && e.key === ' ') {
                                        onClear();
                                    }
                                }, onClick: function (e) {
                                    if (!disabled) {
                                        e.stopPropagation();
                                        onClear();
                                    }
                                }, "data-testid": (0, test_helpers_1.generateTestId)(testId, 'close') }))) : (react_1.default.createElement(button_1.Button, { onClick: onSelect, size: "secondary", disabled: disabled, type: "button", testId: (0, test_helpers_1.generateTestId)(testId, 'button') },
                            react_1.default.createElement(stack_1.Stack, { gap: 8, alignItems: "center" },
                                iconType === 'filter' && react_1.default.createElement(icons_1.IconFilter, null),
                                iconType === 'sort' && react_1.default.createElement(icons_1.IconSort, null),
                                buttonLabel)))))),
                children)),
        error && (react_1.default.createElement(text_1.Text, { color: "error", display: "block", marginTop: 4 }, error))));
}
exports.ObjectSelectionInput = ObjectSelectionInput;
//# sourceMappingURL=index.js.map